import SectionMessage from '@atlaskit/section-message';
import Image from '@atlaskit/image';
import objectSizeDark from "../../../../../../packages/design-system/object/constellation/index/images/object-size-dark.png";
import objectSizeLight from "../../../../../../packages/design-system/object/constellation/index/images/object-size-light.png";
import objectColorsDo from "../../../../../../packages/design-system/object/constellation/index/images/do-donts/object-colors-do.png";
import objectColorsDont from "../../../../../../packages/design-system/object/constellation/index/images/do-donts/object-colors-dont.png";
import objectLargerDo from "../../../../../../packages/design-system/object/constellation/index/images/do-donts/object-larger-do.png";
import objectLargerDont from "../../../../../../packages/design-system/object/constellation/index/images/do-donts/object-larger-dont.png";
import * as React from 'react';
export default {
  SectionMessage,
  Image,
  objectSizeDark,
  objectSizeLight,
  objectColorsDo,
  objectColorsDont,
  objectLargerDo,
  objectLargerDont,
  React
};